import { c as _c } from "react/compiler-runtime";
import { CouponDetailResponse } from '@/api/skippay/coupon';
import { Button } from '@/components/buttons';
import { CopyInput } from '@/components/inputs';
import { Modal } from '@/components/modal';
import { LINKS } from '@/constants/links';
import { Maybe, SetState } from '@/utils/types';
import Image from 'next/image';
import { useTranslation } from 'react-i18next';
interface Props {
  coupon: CouponDetailResponse;
  isVisible: boolean;
  setIsVisible: SetState<boolean>;
}
export function CouponModal(props) {
  const $ = _c(12);
  const {
    coupon
  } = props;
  const {
    t
  } = useTranslation("discounts");
  const image = coupon?.imageUrl || "/images/sections/discounts/discounts-modal-default.png";
  const code = coupon?.code as Maybe<string>;
  let t0;
  if ($[0] !== props) {
    t0 = () => props.setIsVisible(false);
    $[0] = props;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== code || $[3] !== coupon || $[4] !== image || $[5] !== props || $[6] !== t) {
    t1 = coupon && <section className="grid grid-cols-1 md:grid-cols-7 md:gap-16"><div className="relative col-span-1 md:col-span-3">{coupon.merchant.logoUrl && <Image className="absolute top-1/2 left-1/2 h-fit w-20 max-w-30 -translate-x-1/2 -translate-y-1/2 transform lg:max-w-80" width={175} height={140} src={coupon.merchant.logoUrl} alt={coupon.merchant.name || ""} />}<Image className="aspect-[2/1] min-h-52 overflow-hidden rounded-3xl object-cover md:aspect-square" width={466} height={466} src={image} alt={coupon.merchant.name || ""} /></div><div className="col-span-1 md:col-span-4"><div className="md:shadown-scroll flex max-h-[60vh] flex-col overflow-y-auto md:max-h-80 md:justify-center"><h2 className="mb-4 pt-8 text-lg font-bold md:pt-20 md:text-4xl">{coupon.title}</h2><p>{coupon.description}</p></div><div className="fixed bottom-0 left-0 w-full bg-white p-4 md:relative md:mt-10 md:p-0">{code && <CopyInput className="mb-4" value={code} helpText={t("modal.code")} />}<div className="flex gap-2">{coupon.linkToStore && <Button analyticsParam="couponModalEshopDetail" testId="couponModalEshopDetail" variant="secondary" size="lg" to={LINKS().discountsDetail(coupon.linkToStore)} onClick={() => props.setIsVisible(false)} className="w-full">{t("modal.eshopDetail")}</Button>}<Button analyticsParam="couponModalEshopLink" testId="couponModalEshopLink" variant="primary" size="lg" to={coupon.url} className="w-full">{t("modal.eshopLink")}</Button></div></div></div></section>;
    $[2] = code;
    $[3] = coupon;
    $[4] = image;
    $[5] = props;
    $[6] = t;
    $[7] = t1;
  } else {
    t1 = $[7];
  }
  let t2;
  if ($[8] !== props.isVisible || $[9] !== t0 || $[10] !== t1) {
    t2 = <Modal analyticsParam="couponDetail" testId="couponDetail" modalName="couponDetail" onClose={t0} isVisible={props.isVisible} className="inset-0 h-full rounded-none bg-blue-100 p-4 pl-4 md:inset-4 md:h-fit md:rounded-4xl md:bg-white md:py-8 md:pr-16 md:pl-8" closeButtonClassName="bg-white md:bg-inherit rounded-lg p-1">{t1}</Modal>;
    $[8] = props.isVisible;
    $[9] = t0;
    $[10] = t1;
    $[11] = t2;
  } else {
    t2 = $[11];
  }
  return t2;
}